import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { createStructuredSelector } from "reselect";
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  Lookup,
  MasterDetail,
} from "devextreme-react/data-grid";
import { selectWarehouses } from "../../redux/cash-in-out/cash-in-out-selectors";
import { getNavigatorLanguage } from "../../utils";
import { locale } from "devextreme/localization";
import Spinner from "../common/Spinner";
import TransactionDetailTemplate from "./TransactionDetailTemplate";

const Overview = ({ reportStore, isLoading, isExporting, exportReport }) => {
  const { warehouses } = useSelector(
    createStructuredSelector({
      warehouses: selectWarehouses,
    })
  );

  useEffect(() => {
    locale(getNavigatorLanguage());
  }, []);

  const onToolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(function (item) {
      item.showText = true;

      if (item.name === "searchPanel" || item.name === "columnChooserButton") {
        item.location = "after";
      } else {
        item.location = "before";
      }
    });

    toolbarItems.unshift({
      widget: "dxButton",
      options: {
        icon: "docfile",
        text: "Export to CSV",
        hint: "Export to CSV",
        onClick: exportReport,
        stylingMode: "contained",
        type: "normal",
        disabled: !reportStore.length || isExporting,
      },
      location: "before",
      locateInMenu: "auto",
    });
  };

  return (
    <div style={{ marginTop: "20px", marginBottom: "50px" }}>
      {reportStore && !isLoading && (
        <DataGrid
          id='gridContainer'
          keyExpr='id'
          dataSource={reportStore}
          showBorders={true}
          hoverStateEnabled={true}
          focusedRowEnabled={true}
          defaultFocusedRowIndex={0}
          cellHintEnabled={true}
          remoteOperations={false}
          showRowLines={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          showColumnLines={true}
          rowAlternationEnabled={true}
          wordWrapEnabled={true}
          onToolbarPreparing={onToolbarPreparing}
        >
          <HeaderFilter visible={true} />
          <FilterRow visible={true} applyFilter='auto' />

          {/* <Export
            enabled={true}
            excelWrapTextEnabled={true}
            fileName="Tax_Payable_Report"
            allowExportSelectedData={true}
          /> */}

          <Paging defaultPageSize={50} />
          <Pager
            showNavigationButtons={true}
            showPageSizeSelector={true}
            allowedPageSizes={[50, 100, 200]}
            showInfo={true}
          />
          <Column dataField='pointOfSale.name' caption='Register' />
          <Column dataField='warehouse.id' caption='Location'>
            <Lookup
              dataSource={warehouses}
              valueExpr='warehouseID'
              displayExpr='name'
            />
          </Column>
          <Column
            dataField='openedAt'
            caption='Shift Start Time'
            dataType='datetime'
          />
          <Column
            dataField='closedAt'
            caption='Shift End Time'
            dataType='datetime'
          />

          <MasterDetail
            enabled={true}
            autoExpandAll={true}
            component={TransactionDetailTemplate}
          />
        </DataGrid>
      )}
      {isLoading && <Spinner />}
    </div>
  );
};

export default Overview;
